(function(){
var Q=window.MHTQA;if(!Q||Q.op)return;
Q.op=function(p,cart){
var E=Q.E,url=location.origin+p.url,qmap={};(cart.items||[]).forEach(function(li){qmap[li.id]=(qmap[li.id]||0)+li.quantity;});
var ov=E('div','mhtqa-ov'),b=E('div','mhtqa-box'),h=E('div','mhtqa-head');
h.appendChild(E('h3','mhtqa-title','Veuillez s\u00e9lectionner une option'));
var x=E('button','mhtqa-x','\u00D7');x.type='button';x.onclick=Q.close;h.appendChild(x);b.appendChild(h);
var hero=E('div','mhtqa-hero');
if(p.featured_image){var im=E('img','mhtqa-himg');im.src=p.featured_image;im.alt=p.title;hero.appendChild(im);}
hero.appendChild(E('div','mhtqa-htitle',p.title));b.appendChild(hero);var ship=E('div','mhtqa-ship');b.appendChild(ship);
var list=E('div','mhtqa-list'),rows=[];
p.variants.forEach(function(v){
var r=E('div','mhtqa-row'),i=E('div','mhtqa-info'),nm=v.title==='Default Title'?'':v.title;
if(nm)i.appendChild(E('div','mhtqa-vn',nm));
i.appendChild(E('div','mhtqa-pr',Q.m(v.price)));r.appendChild(i);
if(v.available){
var q=E('div','mhtqa-q'),mi=E('button','mhtqa-b','\u2212'),va=E('span','mhtqa-v',String(qmap[v.id]||0)),pl=E('button','mhtqa-b mhtqa-p','+'),busy=false;
mi.type=pl.type='button';
function upd(d){if(busy)return;var cur=parseInt(va.textContent,10)||0,nq=cur+d;if(nq<0)return;busy=true;mi.disabled=pl.disabled=true;
(d>0?Q.add(v.id):Q.dec(v.id,nq)).then(function(){va.textContent=nq;total();Q.toast(d>0?'Produit ajout\u00e9 avec succ\u00e8s':'Produit retir\u00e9',d>0);Q.bubble();}).catch(function(){Q.toast(d>0?'Stock indisponible':'Une erreur est survenue',false);}).then(function(){busy=false;mi.disabled=pl.disabled=false;});}
mi.onclick=function(){upd(-1);};pl.onclick=function(){upd(1);};
q.appendChild(mi);q.appendChild(va);q.appendChild(pl);r.appendChild(q);
rows.push({price:v.price,va:va});
}else{r.appendChild(E('span','mhtqa-oos','Rupture'));}
list.appendChild(r);
});
b.appendChild(list);
var reco=E('div','mhtqa-reco');b.appendChild(reco);if(Q.reco)Q.reco(p,reco);
var sub=E('div','mhtqa-sub');sub.appendChild(E('span',null,'Sous-total'));var subv=E('b',null,Q.m(cart.total_price||0));sub.appendChild(subv);b.appendChild(sub);
function total(){if(Q.ship)Q.ship();}
total();
var a=E('div','mhtqa-acts');
var c=E('button','mhtqa-cont','Poursuivre vos achats');c.type='button';c.onclick=Q.close;
var g=E('button','mhtqa-go','Acc\u00e9der au panier');g.type='button';g.onclick=function(){Q.openDrawer();};
a.appendChild(c);a.appendChild(g);b.appendChild(a);
var wa=E('a','mhtqa-wa','\uD83D\uDCAC Commander sur WhatsApp');
wa.href='https://wa.me/'+Q.WA+'?text='+encodeURIComponent('Bonjour MHT, je souhaite commander : '+p.title+' ('+url+')');
wa.target='_blank';wa.rel='noopener';b.appendChild(wa);
ov.appendChild(b);Q.mount(ov);if(Q.ship)Q.ship();
};
})();